import { render } from "./AppInfoTitles.vue?vue&type=template&id=2f7ceaf4&ts=true"
import script from "./AppInfoTitles.vue?vue&type=script&lang=ts"
export * from "./AppInfoTitles.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__